import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";

const WS_BASE = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");

export default function useTracking(orderId, enabled = true) {
  const [delivery, setDelivery] = useState(undefined);
  const [mode, setMode] = useState("connecting");
  const timers = useRef({});

  useEffect(() => {
    if (!enabled || !orderId) return undefined;
    let ws, closed = false;
    const t = timers.current;
    const poll = () => api.get(`/orders/${orderId}/tracking`).then(({ data }) => setDelivery(data.delivery)).catch(() => {});
    const startPolling = () => {
      setMode("polling");
      poll();
      clearInterval(timers.current.poll);
      timers.current.poll = setInterval(poll, 10000);
      clearTimeout(timers.current.retry);
      timers.current.retry = setTimeout(connect, 30000);
    };
    async function connect() {
      if (closed) return;
      let ticket;
      try { ({ data: { ticket } } = await api.post(`/orders/${orderId}/ws-ticket`)); } catch { startPolling(); return; }
      if (closed) return;
      try { ws = new WebSocket(`${WS_BASE}/api/bo/ws/orders/${orderId}?ticket=${encodeURIComponent(ticket)}`); } catch { startPolling(); return; }
      ws.onopen = () => { setMode("live"); clearInterval(timers.current.poll); clearInterval(timers.current.ping);
        timers.current.ping = setInterval(() => ws.readyState === 1 && ws.send("ping"), 25000); };
      ws.onmessage = (e) => { try { const msg = JSON.parse(e.data); if (msg.type === "tracking") setDelivery(msg.delivery); } catch { /* ignore */ } };
      ws.onclose = () => { clearInterval(timers.current.ping); if (!closed) startPolling(); };
    }
    connect();
    return () => { closed = true; ws?.close(); Object.values(t).forEach((x) => { clearInterval(x); clearTimeout(x); }); };
  }, [orderId, enabled]);

  return { delivery, mode };
}
